"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.GLOBAL_NAV_HEIGHT = exports.FOLLOW_BUTTON_STYLES = exports.SOLITARY_BUTTON_STYLE = exports.STANDARD_BUTTON_STYLE = exports.FOLLOW_BUTTON_SIZES = exports.MINI_BUTTON_SIZE = exports.COMPACT_BUTTON_SIZE = exports.STANDARD_BUTTON_SIZE = exports.CARD_SIZES = exports.MINI_SIZE = exports.STANDARD_SIZE = exports.FOLLOW_LIST_STYLES = exports.CARD_TYPES = exports.LIST_TYPE = exports.GRID_TYPE = void 0;
// Card and List Types
var GRID_TYPE = 'grid';
exports.GRID_TYPE = GRID_TYPE;
var LIST_TYPE = 'list';
exports.LIST_TYPE = LIST_TYPE;
var CARD_TYPES = [GRID_TYPE, LIST_TYPE];
exports.CARD_TYPES = CARD_TYPES;
var FOLLOW_LIST_STYLES = [GRID_TYPE, LIST_TYPE]; // Card Sizes

exports.FOLLOW_LIST_STYLES = FOLLOW_LIST_STYLES;
var STANDARD_SIZE = 'standard';
exports.STANDARD_SIZE = STANDARD_SIZE;
var MINI_SIZE = 'mini';
exports.MINI_SIZE = MINI_SIZE;
var CARD_SIZES = [STANDARD_SIZE, MINI_SIZE]; // Button Sizes

exports.CARD_SIZES = CARD_SIZES;
var STANDARD_BUTTON_SIZE = 'standard';
exports.STANDARD_BUTTON_SIZE = STANDARD_BUTTON_SIZE;
var COMPACT_BUTTON_SIZE = 'compact';
exports.COMPACT_BUTTON_SIZE = COMPACT_BUTTON_SIZE;
var MINI_BUTTON_SIZE = 'mini';
exports.MINI_BUTTON_SIZE = MINI_BUTTON_SIZE;
var FOLLOW_BUTTON_SIZES = [COMPACT_BUTTON_SIZE, MINI_BUTTON_SIZE, STANDARD_BUTTON_SIZE]; // Button Styles

exports.FOLLOW_BUTTON_SIZES = FOLLOW_BUTTON_SIZES;
var STANDARD_BUTTON_STYLE = 'standard';
exports.STANDARD_BUTTON_STYLE = STANDARD_BUTTON_STYLE;
var SOLITARY_BUTTON_STYLE = 'solitary';
exports.SOLITARY_BUTTON_STYLE = SOLITARY_BUTTON_STYLE;
var FOLLOW_BUTTON_STYLES = [STANDARD_BUTTON_STYLE, SOLITARY_BUTTON_STYLE];
exports.FOLLOW_BUTTON_STYLES = FOLLOW_BUTTON_STYLES;
var GLOBAL_NAV_HEIGHT = 60;
exports.GLOBAL_NAV_HEIGHT = GLOBAL_NAV_HEIGHT;